import { TdProps } from 'app/common/ui-components/table'
import { COLOR_PODUCTION_TYPE } from './cell-colors'
import { extractDateAndNameFromColumnKey } from './create-column-keys'
import { Entity } from './types'

const defaultCellsProps = {
  [Entity.Title]: { alignLeft: true },
  [Entity.TotalCount]: { alignCenter: true },
  [Entity.TotalSum]: { alignCenter: true },
  [Entity.DateCount]: { alignCenter: true },
  [Entity.DateSum]: { alignCenter: true, borderRight: true },
  [Entity.IsOnlyTitle]: { alignLeft: true, bgColor: COLOR_PODUCTION_TYPE, colSpan: 3 },
}

export const createDataProps = ({
  firstColumnWidht,
  lastColumnWidth,
}: {
  firstColumnWidht?: number
  lastColumnWidth?: number
} = {}) => {
  return new Proxy(defaultCellsProps, {
    get: function (target, property) {
      if (property === Entity.Title && firstColumnWidht)
        return { ...target[Entity.Title], width: firstColumnWidht }
      if (property === Entity.TotalCount && lastColumnWidth)
        return { ...target[Entity.TotalCount], width: lastColumnWidth / 2 }
      if (property === Entity.TotalSum && lastColumnWidth)
        return { ...target[Entity.TotalSum], width: lastColumnWidth / 2 }
      const res = target[property as string]
      if (!res) {
        const [name] = extractDateAndNameFromColumnKey(property as string)
        return target[name] || {}
      }
      return res || {}
    },
  })
}

const defaultTotalCellsProps = {
  [Entity.Title]: { alignRight: true, bold: true },
  [Entity.TotalCount]: { alignCenter: true, bold: true },
  [Entity.TotalSum]: { alignCenter: true, bold: true },
  [Entity.DateCount]: { alignCenter: true, bold: true, highlighted: true },
  [Entity.DateSum]: { alignCenter: true, borderRight: true, bold: true, highlighted: true },
}

export const createTotalDataProps = ({
  firstColumnWidht,
  lastColumnWidth,
}: {
  firstColumnWidht?: number
  lastColumnWidth?: number
} = {}) => {
  return new Proxy(defaultTotalCellsProps, {
    get: function (target, property) {
      if (property === Entity.Title && firstColumnWidht)
        return { ...target[Entity.Title], width: firstColumnWidht }
      if (property === Entity.TotalCount && lastColumnWidth)
        return { ...target[Entity.TotalCount], width: lastColumnWidth / 2 }
      if (property === Entity.TotalSum && lastColumnWidth)
        return { ...target[Entity.TotalSum], width: lastColumnWidth / 2 }
      const res = target[property as string]
      if (!res) {
        const [name] = extractDateAndNameFromColumnKey(property as string)
        return target[name] || {}
      }
      return res || {}
    },
  })
}

export const tdPropsByRowAndColumnKey = ({
  side,
  rowKey,
}: {
  side: 'left' | 'right' | 'main'
  rowKey: string
  columnKey: string
}) => {
  const props = {} as Omit<TdProps, 'children' | 'className'>
  if (rowKey.includes(Entity.IsOnlyTitle)) {
    props.bgColor = COLOR_PODUCTION_TYPE
    if (side === 'main') props.borderRight = false
  }
  return props
}
